export default "__VITE_ASSET__CPIDnlZF__"